/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { IgrFormatLinearGraphLabelEventArgs } from "./igr-format-linear-graph-label-event-args";
import { AlignLinearGraphLabelEventArgs as AlignLinearGraphLabelEventArgs_internal } from "./AlignLinearGraphLabelEventArgs";
/**
 * Represents event argument for AlignLinearGraphLabel.
*/
var IgrAlignLinearGraphLabelEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(IgrAlignLinearGraphLabelEventArgs, _super);
    function IgrAlignLinearGraphLabelEventArgs() {
        return _super.call(this) || this;
    }
    IgrAlignLinearGraphLabelEventArgs.prototype.createImplementation = function () {
        return new AlignLinearGraphLabelEventArgs_internal();
    };
    Object.defineProperty(IgrAlignLinearGraphLabelEventArgs.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAlignLinearGraphLabelEventArgs.prototype, "width", {
        get: function () {
            return this.i.width;
        },
        set: function (value) {
            this.i.width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAlignLinearGraphLabelEventArgs.prototype, "height", {
        get: function () {
            return this.i.height;
        },
        set: function (value) {
            this.i.height = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAlignLinearGraphLabelEventArgs.prototype, "offsetX", {
        get: function () {
            return this.i.offsetX;
        },
        set: function (value) {
            this.i.offsetX = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrAlignLinearGraphLabelEventArgs.prototype, "offsetY", {
        get: function () {
            return this.i.offsetY;
        },
        set: function (value) {
            this.i.offsetY = value;
        },
        enumerable: false,
        configurable: true
    });
    return IgrAlignLinearGraphLabelEventArgs;
}(IgrFormatLinearGraphLabelEventArgs));
export { IgrAlignLinearGraphLabelEventArgs };
